import React, { Component } from 'react';
import { Card, Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2 } from "reactstrap";
import { api, filterHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyProductGroup = {
  name: '',
  displayOrder: null,
}

export default class ProductGroup extends Component {
  static displayName = ProductGroup.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      editProductGroup: null,
      productGroupList: [],
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,

    }
    this.addProductGroup = this.addProductGroup.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);

  }

  componentDidMount() {
    this.onChangeFilter({
      filterName: "activeOnly",
      value: true,
      filteredDisplay: "Active Only"
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/ProductGroups", payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editProductGroup: null,
            message: null,
            messageColor: null,
            isMessageVisible: false,
          });
        }
    })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addProductGroup() {
    this.setState({
      editProductGroup: emptyProductGroup
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editProductGroup: { ...this.state.editProductGroup, [fieldName]: e.target.value }
    })
  }

  onCancel() {
    this.setState({
      editProductGroup: null
    });
  }

  onSave() {
    let group = Object.assign({}, this.state.editProductGroup);
    if (group.name === "") {
      this.setState({ message: "Please enter a Group Name.", messageColor: "danger" });
      return;
    }
    if (group.displayOrder === null) {
      this.setState({ message: "Display Order is required.", messageColor: "danger" });
      return;
    }

    let payload = {
      Name: group.name,
      DisplayOrder: parseInt(group.displayOrder, 10)
    }
    if (group.id) {
      payload.Id = group.id;
    }
    api.post("Admin/SaveProductGroup", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${group.name} has been saved.`)
          this.refreshList();
          this.props.refreshAll();

        } else {
          Alert.error("An error occurred.  The product group could not be created at this time.")
        }
      }).catch(error => Alert.error("There was an error creating the Product Group."));
  }

  onEdit(productGroupId) {
    let list = this.state.pagedList.list.slice();
    let group = _.find(list, g => {
      return g.id === productGroupId
    })
    this.setState({
      editProductGroup: group
    });
    window.scrollTo(0, 0);
  }

  onDelete(productGroupId) {
    if (!window.confirm(`Are you sure you'd like to delete this product group?`)) return;

    api.delete(`Admin/DeleteProductGroup/${productGroupId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Product Group was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Product Group cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the Product Group.")
      });
  }

  onRevive(productGroupId) {
    api.post("Admin/ReviveProductGroup", productGroupId)
      .then(response => {
        if (response.data.success) {
          Alert.success("Product Group was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Product Group cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the Product Group."));
  }

  render() {
    let editProductGroup = this.state.editProductGroup;
    return (
      <div>
        <Row>
          <Col><h5>Product Groups</h5></Col>
          <Col className="mr-3">
            {this.state.editProductGroup ? null : (
              <Button size="sm" color="success" className="float-right" onClick={this.addProductGroup}>Add New Product Group</Button>
            )}
          </Col>
        </Row>
        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editProductGroup ? (
          <Card className="p-2">
            <Row>
              <Col>Name: <Input type="text" maxLength="40" name="name" id="name" onChange={(e) => this.onInputChange(e, "name")} value={editProductGroup.name} /></Col>
              <Col>Display Order: <Input type="number" name="displayOrder" id="displayOrder" onChange={(e) => this.onInputChange(e, "displayOrder")} value={editProductGroup.displayOrder} /></Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" className="buttonGroupSpacing"  onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>{editProductGroup.id ? "Update" : "Save"}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Display Order</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(group => (
                    <tr key={`pg-${group.id}`}>
                      <td>{group.name}</td>
                      <td>{group.displayOrder}</td>
                      <td>
                        <ButtonGroup className="float-right">
                          {group.deactivatedAt === null ? (
                            <React.Fragment>
                              <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onEdit(group.id)} disabled={this.state.editProductGroup !== null} title="Edit">
                                <FontAwesomeIcon
                                  icon="edit"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer"
                                  title="Edit"
                                />
                              </Button>
                              <Button size="sm" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(group.id)} disabled={this.state.editProductGroup !== null} title="Delete">
                                <FontAwesomeIcon
                                  icon="trash-alt"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer "
                                  title="Delete"
                                />

                              </Button>
                            </React.Fragment>
                          ) : (
                              <Button size="sm" className="cbdmdInfoTeal" onClick={() => this.onRevive(group.id)} disabled={this.state.editProductGroup !== null}>Revive</Button>
                          )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      No Records available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductGroup.js